import React, {useState, useCallback, useRef} from 'react';
// import ReactDOM from 'react-dom';
import {openModal, closeAll} from '../utils/Modal'

const ModalVideo = () => {

  const videoRef = useRef();
  const [paused, setPaused] = useState(false)

  const pauseToggle = useCallback(
    () => {
      setPaused((state) => !state);
      videoRef.current.paused ? videoRef.current.play() : videoRef.current.pause()
    },
    [],
  );

  // const renderContent= useCallback(
  //   () => {
      return (
      <section className="modal-video">
        <button className="close-overlay" onClick={() => closeAll()}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.5 1.5L1.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.5 1.5L10.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        </button>
        <div className="video-box">
          <div className="intro-video">
            <video ref={videoRef} src="/video/video-3.mp4" alt=""/>
            <button type="button" className={`play-button ${paused ? 'pause' : ''}`} onClick={pauseToggle}/>
          </div>
        </div>
      </section>
      )
  //   },
  //   [modalShow, ModalToggle],
  // )

  // return (<>
  //    {ReactDOM.createPortal(renderContent(), document.getElementById('modal'))}
  //   </>
    
  // );
};

export default ModalVideo;
